import { Outlet } from 'react-router-dom';
import { Container } from 'reactstrap';
import { NavMenu } from './components/NavMenu';
import './custom.css';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { useValidateLogin } from './Login/LoginRedirect';
import { useEffect } from 'react';
library.add(fas);

export default function App() {
    const validate = useValidateLogin();

    useEffect(() => {
        validate();
    }, [validate]);

    return (
        <>
            <NavMenu />
            <Container>
                <Outlet />
            </Container>
        </>
    );
}
